import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const ServicesPage = lazy(() => import('../pages/services/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

// Individual Service Pages
const EmergencyWorkPage = lazy(() => import('../pages/services/emergency-work/page'));
const CeilingFansPage = lazy(() => import('../pages/services/ceiling-fans/page'));
const PowerPointsPage = lazy(() => import('../pages/services/power-points/page'));
const FaultDetectionPage = lazy(() => import('../pages/services/fault-detection/page'));
const SmokeAlarmsPage = lazy(() => import('../pages/services/smoke-alarms/page'));
const LightingPage = lazy(() => import('../pages/services/lighting/page'));
const ElectricalRepairsPage = lazy(() => import('../pages/services/electrical-repairs/page'));
const WiringRewiringPage = lazy(() => import('../pages/services/wiring-rewiring/page'));
const SurgeProtectionPage = lazy(() => import('../pages/services/surge-protection/page'));
const SwitchboardsPage = lazy(() => import('../pages/services/switchboards/page'));
const ElectricalMaintenancePage = lazy(() => import('../pages/services/electrical-maintenance/page'));
const SolarBatteriesPage = lazy(() => import('../pages/services/solar-batteries/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/services',
    element: <ServicesPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/services/emergency-work',
    element: <EmergencyWorkPage />,
  },
  {
    path: '/services/ceiling-fans',
    element: <CeilingFansPage />,
  },
  {
    path: '/services/power-points',
    element: <PowerPointsPage />,
  },
  {
    path: '/services/fault-detection',
    element: <FaultDetectionPage />,
  },
  {
    path: '/services/smoke-alarms',
    element: <SmokeAlarmsPage />,
  },
  {
    path: '/services/lighting',
    element: <LightingPage />,
  },
  {
    path: '/services/electrical-repairs',
    element: <ElectricalRepairsPage />,
  },
  {
    path: '/services/wiring-rewiring',
    element: <WiringRewiringPage />,
  },
  {
    path: '/services/surge-protection',
    element: <SurgeProtectionPage />,
  },
  {
    path: '/services/switchboards',
    element: <SwitchboardsPage />,
  },
  {
    path: '/services/electrical-maintenance',
    element: <ElectricalMaintenancePage />,
  },
  {
    path: '/services/solar-batteries',
    element: <SolarBatteriesPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;